import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  CollapsibleContentClose: {
    maxHeight: 0,
    overflow: 'hidden',
    opacity: 0,
    transition: 'max-height 0.3s ease-out, opacity 0.4s ease-out',
  },
  CollapsibleContentOpen: {
    maxHeight: '100vh',
    overflow: 'visible',
    opacity: 1,
    transition: 'max-height 0.3s ease-in, opacity 0.4s ease-in',
  },
}));
